import React from 'react';

export default function LoadingOverlay({
    isLoading,
    loadingHeadline = 'Adresse wird geprüft...',
    loadingText = 'Bitte haben Sie etwas Geduld.',
    loadingIcon = undefined,
}) {
    const defaultLoadingIconPath = '/etc.clientlibs/magenta_at/mms/clientlibs/clientlib-base/resources/vfc_loading-animation.gif';
    const loadingIconPath = loadingIcon ? `${window.location.origin}${loadingIcon}` : defaultLoadingIconPath;

    return (
        <>
            {isLoading && (
                <div className="website-loading-component">
                    <div className="loading">
                        <div className="loading-animation">
                            <img
                                src={loadingIconPath}
                                alt="Loading"
                                height="82"
                                width="82"
                                aria-hidden="true"
                                role="presentation"
                            />
                        </div>
                        {loadingHeadline && <h3 dangerouslySetInnerHTML={{ __html: loadingHeadline }} />}
                        {loadingText && <p className="huge" dangerouslySetInnerHTML={{ __html: loadingText }} />}
                    </div>
                </div>
            )}
        </>
    );
}
